document.addEventListener("DOMContentLoaded", function() {
    // Get the parent slider class based on the screen width
    const getParentSliderClass = () => {
        return window.innerWidth > 992 ? '.desktop-slider' : '.product_slider_mob';
    };

    // Get the video element from the selected parent slider component
    const getVideoElement = () => {
        const parentClass = getParentSliderClass();
        const parentElement = document.querySelector(parentClass);
        return parentElement ? parentElement.querySelector('video') : null;
    };

    // Play or pause the video based on intersection status
    const playPauseVideo = (entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
            video.play(); 
        } else {
            video.pause(); 
        }
    };

    // Create an IntersectionObserver to monitor the video
    const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(playPauseVideo); 
    }, { threshold: 0.1 }); 

    // Start observing the video element if it exists
    const startObservingVideos = () => {
        const video = getVideoElement();
        if (video) videoObserver.observe(video); 
    };

    // Refresh the observer when the content is updated
    const refreshObserver = () => {
        const video = getVideoElement(); 
        if (video) {
            videoObserver.disconnect(); 
            setTimeout(startObservingVideos, 500); 
        } 
    };

    // Initialize the observer with a delay to ensure all elements are rendered
    setTimeout(startObservingVideos, 2000);

    // Add event listeners for label clicks to refresh the observer
    const sizeSliderLabels = document.querySelectorAll('.size_slider label'); // Select all labels
    sizeSliderLabels.forEach(label => {
        label.addEventListener('click', ()=> {
            const video = getVideoElement(); // Get the video element
            if (video) refreshObserver(); 
        }); 
    });
});
